import * as React from "react";
import { DatasheetFormatManagementMode } from "@modules/datasheets/components/datasheet-format-management/datasheet-format-management.types";
import { DatasheetFormatType } from "@common/dto/datasheet/type";

export const useDatasheetFormatManagementController = () => {
  const [datasheetFormatManagementMode, setDatasheetFormatManagementMode] = React.useState<
    DatasheetFormatManagementMode | undefined
  >();
  const [datasheetFormatManagementInitial, setDatasheetFormatManagementInitial] = React.useState<
    | {
        initialSelectedFormatType?: DatasheetFormatType;
        initialTableField?: { id: number; name: string; context: number };
      }
    | undefined
  >(undefined);

  const closeDatasheetFormatManagement = React.useCallback(() => {
    setDatasheetFormatManagementMode(undefined);
    setDatasheetFormatManagementInitial(undefined);
  }, []);

  const openNewDatasheet = React.useCallback(() => {
    setDatasheetFormatManagementInitial(undefined);
    setDatasheetFormatManagementMode(DatasheetFormatManagementMode.new);
  }, []);

  const openLoadDatasheet = React.useCallback(() => {
    setDatasheetFormatManagementInitial(undefined);
    setDatasheetFormatManagementMode(DatasheetFormatManagementMode.load);
  }, []);

  const openNewTableDatasheet = React.useCallback((tableField: { id: number; name: string; context: number }) => {
    setDatasheetFormatManagementInitial({
      initialSelectedFormatType: DatasheetFormatType.table,
      initialTableField: tableField,
    });
    setDatasheetFormatManagementMode(DatasheetFormatManagementMode.new);
  }, []);

  const handleDatasheetFormatManagementSubmit = React.useCallback(() => {    
    closeDatasheetFormatManagement();
  }, [closeDatasheetFormatManagement]);

  return {
    datasheetFormatManagementMode,
    setDatasheetFormatManagementMode,
    datasheetFormatManagementInitial,
    closeDatasheetFormatManagement,
    openNewDatasheet,
    openLoadDatasheet,
    openNewTableDatasheet,
    handleDatasheetFormatManagementSubmit,
  };
};